<div class="flex flex-row justify-between items-center p-2 md:px-4 text-sm light-background">

    <div>
        <button mat-button color="accent" class="rounded-md accent-outline" (click)="paginator.previousPage()"
            [disabled]="paginator.pageIndex === 0 || recordsManager.isLoading">
            <mat-icon>arrow_back</mat-icon>
            <span class="ml-2 md:inline-block hidden ">{{utils.traslatei18n('PREVIOUS')}}</span>
        </button>
    </div>

    <div class="flex flex-row justify-between items-center text-sm">

        <!-- <div>
            <button *ngFor="let page of pages" style="min-width: unset;" mat-stroked-button class="ea-custom-button"
                [ngClass]="{'ea-primary-bg ea-white-txt' : paginator?.pageIndex === page}" (click)="setPage(page)">
                <span>{{page + 1}}</span>
            </button>
        </div> -->

        <div class="theme-color">
            <records-page-size-select></records-page-size-select>
        </div>


        <div class="text-xs font-bold mx-5  md:flex hidden">{{tableInfo}}</div>
        <div>
            <button mat-button color="accent" class="rounded-md accent-outline" (click)="paginator.nextPage()"
                [disabled]="nextIsDisabled">
                <span class="mr-2 md:inline-block hidden">{{utils.traslatei18n('NEXT')}}</span>
                <mat-icon>arrow_forward</mat-icon>
            </button>
        </div>
    </div>

</div>